import { ReactComponent as StarOutlinedIcon } from "shared/assets/Icons/star-outlined.svg";
import { ReactComponent as HeartOutlinedIcon } from "shared/assets/Icons/heart-outlined.svg";
import { ReactComponent as CalendarIcon } from "@icons/calendar.svg";
import PageModal from "UIPalette/PageModal/PageModal";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FunctionComponent, SVGProps } from "react";
import classNames from "classnames";

export interface JournalIntroductionProps {
  onClickStarted?: () => void;
  showCta?: boolean;
  backTitle?: string;
  backIcon?: FunctionComponent<SVGProps<SVGSVGElement>>;
  onClose?: () => void;
}

export const JournalIntroduction = ({ onClickStarted, showCta = true, backIcon, onClose, backTitle }: JournalIntroductionProps) => {
  const navigate = useNavigate();
  const { t } = useTranslation(undefined, { keyPrefix: "positiveYou.journalIntroduction" });

  const benefits = [
    {
      ...t("benefit1", { returnObjects: true }),
      icon: <StarOutlinedIcon className=" md:w-[30px]" />,
    },
    {
      ...t("benefit2", { returnObjects: true }),
      icon: <CalendarIcon className="w-[55px] md:w-[30px]" />,
    },
    {
      ...t("benefit3", { returnObjects: true }),
      icon: <HeartOutlinedIcon className="w-[75px] md:w-[40px]" />,
    },
  ];

  const handleClickStarted = () => onClickStarted && onClickStarted();

  const handleMaybeLater = () => navigate(-1);

  return (
    <PageModal
      primaryCta={showCta ? { title: t("primaryCta"), onClick: handleClickStarted } : undefined}
      textCta={showCta ? { title: t("textCta"), onClick: handleMaybeLater } : undefined}
      showMobileIcon={!showCta}
      backIcon={backIcon}
      onClose={onClose}
      backTitle={backTitle}
    >
      <div className={classNames("space-y-10", { "mt-10 lg:mt-0": showCta })}>
        <div className="space-y-2 text-center">
          <h1>{t("title")}</h1>
          <p>{t("description")}</p>
        </div>
        <div data-testid="journal-introduction-benefits" className="space-y-8 lg:space-y-6">
          {benefits.map((benefit, index) => (
            <div key={index} className="flex items-center gap-4">
              {benefit.icon}
              <div>
                <p className="font-bold">{benefit.title}</p>
                <p>{benefit.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </PageModal>
  );
};
